import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import pricing from '../../../data/pricing.json';

class Pricing extends Component {
    render() {
        return (
            <div className="demo9 section-padding section bg-light-white">
                <div className="container">
                    <div className="section-header text-center">
                        <div className="section-heading">
                            <h3 className="text-custom-black">Our <span className="text-custom-blue">Pricing</span></h3>
                            <div className="section-description">
                                <p className="text-light-dark">Lorem Ipsum is simply dummy text of the printing and typesetting
                                    industry. Lorem Ipsum has been the industry's standard dummy text.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {/* Data */}
                        {pricing.map((item, i) => (
                            <div className="col-lg-3 col-md-6" key={i}>
                                <div className="pricingTable9 purple mb-xl-30">
                                    <div className="pricingTable-header"> <span className="price-value">{new Intl.NumberFormat().format((item.price).toFixed(0))}<span className="currency">$</span></span>
                                        <h3 className="title">{item.title}</h3>
                                    </div>
                                    <ul className="pricing-content">
                                        {/* Data */}
                                        {item.includes.map((data, i) => (
                                            <li key={i}> {data} </li>
                                        ))}
                                        {/* Data */}
                                    </ul>
                                    <Link to="/contact" className="pricingTable-signup">Buy Now</Link>
                                </div>
                            </div>
                        ))}
                        {/* Data */}
                    </div>
                </div>
            </div>
        );
    }
}

export default Pricing;